import { render } from "./EntityPhasesComponent.vue?vue&type=template&id=42a576ce"
import script from "./EntityPhasesComponent.vue?vue&type=script&lang=js"
export * from "./EntityPhasesComponent.vue?vue&type=script&lang=js"
script.render = render

export default script